import React from "react";

export default function Antipodal() {

    return (
        <div className="col-12 col-md-5 Antipodal">
            <h2 className="antipodeCity big">Antipode City</h2>
            <span><i className="fa-solid fa-rainbow big" /></span>
            <h2>
                <span className="AntipodeTemp">Temp </span>
                <span className="AntipodeUnits">Units</span>
            </h2>
        </div>
    );
  }